import React from 'react';
import { ThemeProvider } from '../Contexts/ThemeContext';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { SidebarNavProvider } from '@aidkitorg/component-library';
import { PaymentsPage } from './Payments/PaymentsPage';
import { PaymentBatchDetailsPage } from './Payments/PaymentBatchDetailsPage';
import { PaymentsProvider } from '../Contexts/PaymentsContext';
import { AdminPanelPage } from './AdminPanelPage';

// TODO: use AppShell to build out an OverviewPage -- this is just temporary to test out the ThemeProvider
const OverviewPage = () => {
  return (
    <AdminPanelPage>
      <></>
    </AdminPanelPage>
  )
}

export const AdminPanelApp = () => {
  let { path } = useRouteMatch();

  return (
    <ThemeProvider>
      <SidebarNavProvider>
        <Switch>
          <Route path={`${path}/overview`} component={OverviewPage} />

          {/* PAYMENTS ROUTES */}
          <Route 
            exact
            path={`${path}/payments`} 
            children={ 
              <PaymentsProvider>
                <PaymentsPage/>
              </PaymentsProvider>
            } 
          />
          <Route 
            path={`${path}/payments/payment-details/:batch_name`}
            children={
              <PaymentsProvider>
                <PaymentBatchDetailsPage/>
              </PaymentsProvider>
            }
          />

        </Switch>
      </SidebarNavProvider>
    </ThemeProvider>      
  )
}

export default AdminPanelApp;